export default {
	computed: {
		user() {
			if (this.$store.getters.user) {
				return this.$store.getters.user;
			}

			return {
				username: null,
				image_url: null,
			};
		},
	},
	methods: {
		auth() {
			const self = this;

			return {
				parse(role) {
					if (role === 'unverified') return 0;
					if (role === 'user') return 1;
					if (role === 'partner') return 2;
					if (role === 'mod') return 3;
					if (role === 'editor') return 4;
					if (role === 'admin') return 5;
					if (role === 'superadmin') return 6;

					return -1;
				},
				check(role, currentRole = null, requireMore = false) {
					try {
						if (!currentRole) currentRole = self.$store.getters.role;

						role = this.parse(role);
						currentRole = this.parse(currentRole);

						if (!requireMore) {
							if (currentRole > 0 && currentRole >= role) return true;
						} else if (currentRole > 0 && currentRole > role) return true;

						return false;
					} catch (e) {
						return false;
					}
				},
				role(role) {
					if (role === 'unverified') return 'No Activado';
					if (role === 'user') return 'Usuario';
					if (role === 'partner') return 'Partner';
					if (role === 'mod') return 'Moderador';
					if (role === 'editor') return 'Editor';
					if (role === 'admin') return 'Admin';
					if (role === 'superadmin') return 'SuperAdmin';

					return '';
				},
			};
		},
	},
};
